/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable @typescript-eslint/no-shadow */
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  NbDialogRef,
  NbDialogService,
  NbToastrService,
  NbCardModule,
  NbIconModule,
  NbButtonModule,
  NbTooltipModule,
  NbCheckboxModule
} from '@nebular/theme';
import { Actions, Store, ofActionCompleted } from '@ngxs/store';
import { elementAt, Observable, Subject, takeUntil } from 'rxjs';
import { OktaRestriction } from 'src/app/core/services/okta-restrictions.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { ViewContentComponent } from 'src/app/features/content/content-table/view-content/view-content.component';
import { ContentState } from 'src/app/features/content/redux/content.state';
import { ViewInsightComponent } from 'src/app/features/insights/insights-table/view-insight/view-insight.component';
import { LoadInsight } from 'src/app/features/insights/redux';
import { SurveysState } from 'src/app/features/surveys/redux';
import { ViewSurveyComponent } from 'src/app/features/surveys/surveys-table/view-survey/view-survey.component';
import { Campaign } from 'src/app/models/campaign';
import { Survey } from 'src/app/models/survey';
import { ACTIONS, CONFIG_REGEX, TIMESTAMP, STATUSES } from 'src/app/shared/constants/general-constants';
import { ENVIRONMENT } from 'src/environments/environment';
import { Content } from '../../../../models/content';
import { Insight } from '../../../../models/insight';
import { TimestampDatePipe } from '../../../../shared/pipes/timestamp-date.pipe';
import { RouterState } from '../../../auth/redux/router-state';
import { InsightsState } from '../../../insights/redux/insights.state';
import { CampaignState } from '../../redux';
import { ManageCampaign, PromotionSuccess } from '../../redux/campaign.actions';
import { CampaignService } from '../../services/campaign.service';
import { CampaignPromotionComponent } from './campaign-promotion-component/campaign-promotion-component.component';
import { CampaignStatusHandlerComponent } from './campaign-status-handler/campaign-status-handler.component';
import { NgIf, NgFor, TitleCasePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { StatsCampaignComponent } from '../stats-campaign/stats-campaign.component';
import { NgxGenericModalComponent } from 'src/app/shared/ui/ngx-generic-modal/ngx-generic-modal.component';
import { WebSocketService } from 'src/app/core/services/web-socket.service';

@Component({
  selector: 'app-view-campaign',
  templateUrl: './view-campaign.component.html',
  styleUrls: ['./view-campaign.component.css', '../../../../shared/common_syles.css'],
  providers: [TimestampDatePipe],
  imports: [
    NbCardModule,
    NbIconModule,
    NbButtonModule,
    NgIf,
    NbTooltipModule,
    NbCheckboxModule,
    NgFor,
    RouterLink,
    FormsModule,
    TitleCasePipe
  ]
})
export class ViewCampaignComponent implements OnInit, OnDestroy {
  public campaign$: Observable<any[]> = inject(Store).select(CampaignState.campaign);
  public activeInsight$: Observable<any[]> = inject(Store).select(InsightsState.insightsActive);
  public inactiveInsight$: Observable<any[]> = inject(Store).select(InsightsState.insightsInactive);
  public content$: Observable<any[]> = inject(Store).select(ContentState.content);
  public survey$: Observable<any[]> = inject(Store).select(SurveysState.surveys);
  public username$: Observable<string> = inject(Store).select(RouterState.username);
  private unsubscribe: Subject<void> = new Subject();

  public campaigns: Campaign[] = [];
  public contents: Content[] = [];
  public insights: Insight[] = [];
  public surveys: Survey[] = [];
  public selectedSurveys = [];
  public username = '';

  public showPromoterUsername = false;
  public displayPromotionButton = false;
  public disablePromotionButton = false;

  public campaign: Campaign;
  public condition_all = [];
  public condition_any = [];
  public condition_not_all = [];
  public condition_not_any = [];
  public time_frame;
  public show_condition = false;

  public sendNewLabel: string = null;
  public sendRepeatLabel: string = null;
  public campaignNameValidator = false;
  public scheduleLabel: string;
  public formattedStartTime = '';
  public formattedEndTime = '';
  public formattedCreatedTime = '';
  public formattedUpdatedDate = '';
  public formattedNextRunTime = '';
  public formattedLastRunTime = '';
  public totalDeliveries: number;
  public averageExecDuration;
  public payloadRecordTypes: string[];
  public statusLabel: string;

  public displayManagementButtons = false;
  public valid_campaign: boolean;

  constructor(
    private utilityService: UtilityService,
    protected ref: NbDialogRef<ViewCampaignComponent>,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService,
    private formatDatePipe: TimestampDatePipe,
    private action$: Actions,
    private service: CampaignService,
    private restrictionService: OktaRestriction,
    private store: Store,
    private socketService: WebSocketService
  ) {}

  public ngOnInit() {
    this.campaign$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
      this.campaigns = data;
      this.campaign = data.find((campaign) => campaign.id === this.campaign.id);
      this.handleUpdate();
    });
    if (this.campaign.responses) {
      this.campaign.responses.forEach((item) => {
        const obj = { name: item.name, id: item.id };
        this.selectedSurveys.push(obj);
      });
    }
    if (this.campaign.condition) {
      this.deserializeCondition();
    }
    this.activeInsight$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
      if (data) {
        this.insights = this.insights.concat(data);
        this.handleUpdate();
      }
    });
    this.inactiveInsight$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
      if (data) {
        this.insights = this.insights.concat(data);
        this.handleUpdate();
      }
    });
    this.content$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
      if (data) {
        this.contents = data;
        this.handleUpdate();
      }
    });
    this.survey$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.surveys = data));
    this.username$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.username = data));

    this.displayManagementButtons = this.restrictionService.manager_permission;
    this.scheduleLabel = this.utilityService.getMatchedFrequencyLabel(this.campaign.schedule_seconds);
    this.campaignNameValidator = this.regexValidator(this.campaign.name);
    this.store.dispatch(new LoadInsight(this.campaign.trigger_id));

    this.action$.pipe(ofActionCompleted(PromotionSuccess), takeUntil(this.unsubscribe)).subscribe((data) => {
      if (data) {
        this.service.loadCampaignsAmplify();
      }
    });
    this.action$.pipe(ofActionCompleted(ManageCampaign), takeUntil(this.unsubscribe)).subscribe((data) => {
      setTimeout(() => {
        this.campaign = data.action.payload;
        this.handleDate();
      }, 300);
    });

    this.handleUpdate();
    this.handleDate();
    this.getDeliveries();

    this.averageExecDuration = this.service.getAverageExecDuration(this.campaign);
    this.valid_campaign = this.service.isValidCampaignType(
      this.campaign,
      this.contents.find((element) => element.content_id === this.campaign.content_id)
    );

    this.statusLabel = this.campaign.enabled ? $localize`Active` : $localize`Inactive`;
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public handleUpdate() {
    this.showPromoterUsername = this.campaign.promoted ? true : false;
    const foundContent = this.contents.find((element) => element.content_id === this.campaign.content_id);

    this.payloadRecordTypes = foundContent?.payload_records?.map((r) => r.payload_record_type);

    if (!ENVIRONMENT.isProduction) {
      const foundInsight = this.insights.find((element) => element.id === Number(this.campaign.trigger_id));

      // Disable promotion button if no insight or no content or the campaign is promoted.
      this.disablePromotionButton =
        foundContent && foundInsight && !this.campaign.promoted && !this.campaign.is_campaign_promotion_in_progress
          ? true
          : false;
      // Do not show button based on user Okta group
      this.displayPromotionButton = this.restrictionService.promotion_permission;
    }
  }

  public handleDate() {
    this.formattedCreatedTime = this.formatDate(this.campaign.created_dttm);
    this.formattedUpdatedDate = this.formatDate(this.campaign.last_updated_dttm);
    this.formattedEndTime = this.formatDate(this.campaign.end_date);
    this.formattedStartTime = this.formatDate(this.campaign.start_date);
    this.formattedNextRunTime = this.formatDate(this.campaign.next_run_time);
    this.formattedLastRunTime = this.formatDate(this.campaign.last_run_time);
  }

  public formatDate = (time) => {
    const formatted_time = this.formatDatePipe.transform(time, TIMESTAMP);
    if (formatted_time) {
      return formatted_time;
    } else {
      return '';
    }
  };

  async getDeliveries() {
    this.totalDeliveries = await this.service.getTotalDeliveries(this.service, this.campaign);
  }

  public regexValidator(value) {
    const regex = new RegExp(String.raw`${CONFIG_REGEX}`, 'i');
    return !regex.test(value);
  }

  public viewInsight(event) {
    const found = this.insights.find((element) => element.id === event);
    if (found) {
      this.dialogService.open(ViewInsightComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: {
          insight: found
        }
      });
    } else {
      this.toastrService.show(status, $localize`Insight with this ID does not exist`, {
        status: 'danger'
      });
    }
  }

  public viewContent(event) {
    const found = this.contents.find((element) => element.content_id === event);
    if (found) {
      this.dialogService.open(ViewContentComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: {
          content: found
        }
      });
    } else {
      this.toastrService.show(status, $localize`Content with this ID does not exist`, {
        status: 'danger'
      });
    }
  }

  public viewSurvey(event) {
    const found = this.surveys.find((element) => element.survey_id === event.id);
    if (found) {
      this.dialogService.open(ViewSurveyComponent, {
        context: {
          survey: Survey.copy(found) as Survey
        }
      });
    } else {
      this.toastrService.show(status, $localize`Survey with this ID does not exist`, {
        status: 'danger'
      });
    }
  }

  public viewCampaign(event) {
    const found = this.campaigns.find((element) => element.id === event);
    if (found) {
      this.dialogService.open(ViewCampaignComponent, {
        context: {
          campaign: Campaign.copy(found) as Campaign
        }
      });
    } else {
      this.toastrService.show(status, $localize`Campaign with this ID does not exist`, {
        status: 'danger'
      });
    }
  }

  public viewStats(event) {
    const found = this.campaigns.find((element) => element.id === event);
    if (found) {
      this.dialogService.open(StatsCampaignComponent, {
        context: {
          campaign: Campaign.copy(found) as Campaign
        }
      });
    } else {
      this.toastrService.show(status, $localize`Campaign with this ID does not exist`, {
        status: 'danger'
      });
    }
  }

  public runOnce(event) {
    if (event.status === STATUSES.RUNNING) {
      this.toastrService.show(status, $localize`Cannot start a running campaign`, { status: 'danger' });
    } else if (this.valid_campaign) {
      const campaign: Campaign = event;
      this.dialogService
        .open(NgxGenericModalComponent, {
          closeOnEsc: false,
          closeOnBackdropClick: false,
          context: {
            title: $localize`Are you sure you want to "Run": `,
            message: campaign.id
          }
        })
        .onClose.subscribe((data) => {
          if (data) {
            this.socketService.setUp();
            this.service
              .runCampaignJob(campaign)
              .pipe(takeUntil(this.unsubscribe))
              .subscribe((data) => {
                setTimeout(() => {
                  this.socketService.sendMessage(data.job_id, campaign.id);
                }, 2000);
              });
          }
        });
    } else {
      this.dialogService.open(NgxGenericModalComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: {
          title: $localize`Run Denied: Invalid Campaign Configuration`,
          message: $localize`Invalid Configuration: This content is set up for the Prime App and is not compatible with ${this.campaign.campaign_type} campaign type. 
            Content for Prime is only compatible with Contextual Message, eCommerce, and Map Dirty campaign types.`,
          displayOkButton: true
        }
      });
    }
  }

  public activateCampaign() {
    const associatedInsight = this.insights.find((element) => element.id === Number(this.campaign.trigger_id));
    if (!associatedInsight) {
      this.toastrService.show(status, $localize`No Insight Associated with the Campaign.`, {
        status: 'danger',
        duration: 6000
      });
    }

    if (!this.valid_campaign) {
      this.dialogService.open(NgxGenericModalComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: {
          title: $localize`Activation Denied: Invalid Campaign Configuration`,
          message: $localize`Invalid Configuration: This content is set up for the Prime App and is not compatible with ${this.campaign.campaign_type} campaign type.
            Content for Prime is only compatible with Contextual Message, eCommerce, and Map Dirty campaign types.`,
          displayOkButton: true
        }
      });
      return;
    }

    this.dialogService.open(CampaignStatusHandlerComponent, {
      closeOnEsc: false,
      closeOnBackdropClick: false,
      context: {
        action: ACTIONS.ACTIVATE,
        campaign: <Campaign>Campaign.copy(this.campaign)
      }
    });
  }

  public deactivateCampaign() {
    this.dialogService.open(CampaignStatusHandlerComponent, {
      closeOnEsc: false,
      closeOnBackdropClick: false,
      context: {
        action: ACTIONS.DEACTIVATE,
        campaign: <Campaign>Campaign.copy(this.campaign)
      }
    });
  }

  public promoteCampaign() {
    if (this.valid_campaign) {
      const content = this.contents.find((element) => element.content_id === this.campaign.content_id);
      this.dialogService.open(CampaignPromotionComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: {
          campaign: <Campaign>Campaign.copy(this.campaign),
          insights: this.insights,
          content,
          username: this.username
        }
      });
    } else {
      this.dialogService.open(NgxGenericModalComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: {
          title: $localize`Run Denied: Invalid Campaign Configuration`,
          message: $localize`Invalid Configuration: This content is set up for the Prime App and is not compatible with ${this.campaign.campaign_type} campaign type. 
            Content for Prime is only compatible with Contextual Message, eCommerce, and Map Dirty campaign types.`,
          displayOkButton: true
        }
      });
    }
  }

  public close() {
    this.ref.close();
  }

  private deserializeCondition() {
    if (this.campaign.condition.AND) {
      this.campaign.condition.AND.forEach((item) => {
        if (item.campaign_id) {
          this.condition_all.push(item);
          this.time_frame = item.time_frame;
        } else if (item.NOT) {
          this.condition_not_all.push(item.NOT);
          this.time_frame = item.NOT.time_frame;
        } else if (item.OR) {
          item.OR.forEach((item) => {
            if (item.campaign_id) {
              this.condition_any.push(item);
              this.time_frame = item.time_frame;
            } else if (item.NOT) {
              this.condition_not_any.push(item.NOT);
              this.time_frame = item.NOT.time_frame;
            }
          });
        }
      });
      this.show_condition = true;
    }
  }
}
